
import { lotesApi } from "../../apis";
import { useLotesStore } from "../../stores/ui/lotes.store";
import Swal from "sweetalert2";




export const listadoLotesXStock = async ({ page, id }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('id',  id);

        const { data } = await lotesApi.get(`/lotes/xstock`, { params });
        useLotesStore.setState({ totalLotes : data.total });
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}




export const crearLoteStock = async (body) => {
    try {
        const isEdit = Boolean(body?.id);
        const request = isEdit ? lotesApi.put(`/${body.id}`, body) : lotesApi.post('/create', body);

        const { data } = await request;
        Swal.fire('Exitoso', data.msg, 'success');
        return true;
    } catch (error) {
        const res  = error?.response?.data;
        const msg  = res?.msg ?? res?.errors?.[0]?.msg ?? 'Error inesperado';
        Swal.fire('Error', msg, 'error');
        return false;
    }
}
